import { Routes } from "@angular/router";
import { accessTokenGuard } from "@app/shared/authentication/guards/access-token.guard";
import { UpdatePasswordComponent } from "./domains/profile/pages/update-password/update-password.component";
import { DeleteAccountComponent } from "./domains/profile/pages/delete-account/delete-account.component";
import { UpdateEmailComponent } from "./domains/profile/pages/update-email/update-email.component";
import { VerifyUpdateEmailComponent } from "./domains/profile/components/verify-update-email/verify-update-email.component";
import { ProfileComponent } from "@app/applications/profile/domains/profile/pages/profile/profile.component";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/consts/translation.constant";
import { getProfileResolver } from "@app/applications/profile/resolvers/profile.resolver";

export const profileRoutes: Routes = [
  {
    path: "profile",
    component: ProfileComponent,
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.PROFILE, TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.AUTH]),
      user: getProfileResolver,
    },
    children: [
      {
        path: "reset-password",
        outlet: "popups",
        component: UpdatePasswordComponent,
        canActivate: [accessTokenGuard],
      },
      {
        path: "delete-account",
        outlet: "popups",
        component: DeleteAccountComponent,
        canActivate: [accessTokenGuard],
      },
      {
        path: "update-email",
        outlet: "popups",
        component: UpdateEmailComponent,
        canActivate: [accessTokenGuard],
      },
      {
        path: "verify-update-email-otp",
        outlet: "popups",
        component: VerifyUpdateEmailComponent,
        canActivate: [accessTokenGuard],
      },
    ],
  },
  {
    path: "my-request",
    loadChildren: () => import("./domains/my-swap-request/my-swap-request.route").then(m => m.mySwapRequestRoute),
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.ROOT]),
    },
  },
];
